import {LogOut, Menu, User as UserIcon} from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { useAppAuth } from '@/contexts/AuthContext'

const roleLabels: Record<string, string> = {
  ADMIN: 'Administrador',
  MODERADOR: 'Moderador',
  GESTOR: 'Gestor',
  COORDENADOR: 'Coordenador',
}

interface TopbarProps {
  title: string
  onAbrirMenu?: () => void
}

function Topbar({ title, onAbrirMenu }: TopbarProps) {
  const { user, logout } = useAppAuth()
  const navigate = useNavigate()

  const handleLogout = () => {
    logout()
    navigate('/')
  }

  return (
    <header className="h-14 sm:h-16 bg-white border-b border-[#E7E9EC] flex items-center justify-between gap-3 px-3.5 sm:px-6 sticky top-0 z-20 pt-[env(safe-area-inset-top)]">
      <div className="flex items-center gap-2 min-w-0">
        <button
          onClick={onAbrirMenu}
          className="lg:hidden -ml-1 w-9 h-9 rounded-lg flex items-center justify-center text-[#4B5563] active:bg-[#F5F6F8]"
          aria-label="Abrir menu"
        >
          <Menu className="w-5 h-5" strokeWidth={1.9} />
        </button>
        <h1 className="text-[15.5px] sm:text-[17px] font-semibold text-[#12141A] tracking-tight truncate">{title}</h1>
      </div>

      <div className="flex items-center gap-2 sm:gap-4 shrink-0">
        <button
          onClick={() => navigate('/perfil')}
          title="Meu Perfil"
          className="flex items-center gap-2.5 sm:pr-3 sm:border-r sm:border-[#E7E9EC] rounded-lg hover:bg-[#F7F8FA] sm:hover:bg-transparent transition-colors px-1 py-1 -mx-1"
        >
          <div className="w-8 h-8 rounded-full bg-[#EEF3FE] flex items-center justify-center overflow-hidden shrink-0 ring-2 ring-transparent hover:ring-[#1E4FBF]/30 transition-all">
            {user?.fotoUrl
              ? <img src={user.fotoUrl} alt={user.nomeCompleto} className="w-full h-full object-cover" />
              : <UserIcon className="w-4 h-4 text-[#1E4FBF]" strokeWidth={1.75} />}
          </div>
          <div className="hidden sm:flex flex-col leading-tight text-left">
            <span className="text-[13px] font-medium text-[#12141A] truncate max-w-[140px]">{user?.nomeCompleto}</span>
            <span className="text-[11.5px] text-[#9CA3AF]">{roleLabels[user?.role || ''] || '-'}</span>
          </div>
        </button>
        <button
          onClick={handleLogout}
          className="flex items-center gap-1.5 text-[13px] font-medium text-[#6B7280] hover:text-[#B91C1C] transition-colors w-9 h-9 sm:w-auto sm:h-auto justify-center sm:justify-start rounded-lg active:bg-[#FEF2F2] sm:active:bg-transparent"
          aria-label="Sair"
        >
          <LogOut className="w-4 h-4" strokeWidth={1.75} />
          <span className="hidden sm:inline">Sair</span>
        </button>
      </div>
    </header>
  )
}

export default Topbar
